import { useEffect } from "react";
import { useAuth } from "react-oidc-context";
import { Navigate } from "react-router-dom";
import { ROUTES } from "src/routes/ROUTES";

const LogoutCallback = () => {
  const auth = useAuth();

  useEffect(() => {
    localStorage.removeItem("auth-token");
    auth.removeUser();
  }, [auth]);

  return <Navigate to={ROUTES.ROOT} replace />;
};

export default LogoutCallback;
